export const DATA_TYPE_MAP = {
    year: 'year',
    sqft: 'sqft',
    money: 'money',
    float: 'float',
    days: 'days',
    date: 'date',
    none: 'none'
};

// export const searchModuleType = {
//     bigMap: 'big-map',
//     gridList: 'grid-list'
// };
